import moment from 'moment'
import { TABLA_CUMPLIMIENTO_DE_CUPOS_EXPORTADOR, TABLA_CUMPLIMIENTO_DE_CUPOS_NOMINABLES } from '../../../../../config/tables'
import { CUMPLIMIENTO_CUPO_ASIGNADO_TO_PRINT, CUMPLIMIENTO_CUPO_NOMINABLE_TO_PRINT, getColumnas, getColumnasNominables } from './constantesCumplimientoDeCupos'
import { TablaConsultaCumplimientoDeCuposService } from '../servicio/tabla_consulta_cumplimiento_de_cupos'
import { pdfCustomToolbarGenerator } from '../../../../../models/tools/generarPdf'

export function parseData (data) {
  const parsedData = []
  data.map((entry) => {
    const sinNominar = entry.cantidadAsignadaNominables - entry.cantidadNominada
    const sinConsumir = (entry.cantidadNominada + entry.cantidadAsignadaLibres) - entry.totalConsumidos
    return parsedData.push({ ...entry, entry: entry, sinNominar: sinNominar, sinConsumir: sinConsumir })
  })
  return parsedData
}

export function getCumplimientoCuposVigentes (roles) {
  return dispatch => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_CUMPLIMIENTO_DE_CUPOS_EXPORTADOR
    })

    const rol = roles.filter(roles => roles === 'EXPORTADOR')

    TablaConsultaCumplimientoDeCuposService.getCumplimientoCuposVigente().then(callback)
    function callback (d) {
      const data = parseData(d)
      const customToolbar = pdfCustomToolbarGenerator(
        'Estadísticas cumplimiento de cupos vigentes',
        data,
        CUMPLIMIENTO_CUPO_ASIGNADO_TO_PRINT,
        'landscape'
      )
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: getColumnas(rol),
          data: data,
          title: `Estadísticas cumplimiento de cupos vigentes`,
          isLoading: false,
          fixed2Decimales: false,
          extraOptions: {
            customToolbar,
            pagination: false,
            search: false,
            download: true,
            tableBodyMaxHeight: '450px',
            print: false
          }
        },
        id: TABLA_CUMPLIMIENTO_DE_CUPOS_EXPORTADOR
      })
    }
  }
}

export function getCumplimientoCuposAsignados (roles, fechaD, fechaH) {
  return dispatch => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_CUMPLIMIENTO_DE_CUPOS_EXPORTADOR
    })

    const rol = roles.filter(roles => roles === 'EXPORTADOR')
    const fechaDesde = moment(fechaD).format('YYYY-MM-DD')
    const fechaHasta = moment(fechaH).format('YYYY-MM-DD')

    TablaConsultaCumplimientoDeCuposService.getCumplimientoCuposAsignados(fechaDesde, fechaHasta).then(callback)
    function callback (d) {
      const data = parseData(d)
      const customToolbar = pdfCustomToolbarGenerator(
        'Estadísticas cumplimiento de cupos asignados',
        data,
        CUMPLIMIENTO_CUPO_ASIGNADO_TO_PRINT,
        'landscape'
      )
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: getColumnas(rol),
          data: data,
          title: `Estadísticas cumplimiento de cupos asignados`,
          isLoading: false,
          fixed2Decimales: false,
          extraOptions: {
            customToolbar,
            pagination: false,
            search: false,
            download: true,
            tableBodyMaxHeight: '380px',
            print: false
          }
        },
        id: TABLA_CUMPLIMIENTO_DE_CUPOS_EXPORTADOR
      })
    }
  }
}

export function getCumplimientoCuposNominables (roles, fechaDesde, fechaHasta) {
  return dispatch => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_CUMPLIMIENTO_DE_CUPOS_NOMINABLES
    })

    const fechaD = moment(fechaDesde).format('YYYY-MM-DD')
    const fechaH = moment(fechaHasta).format('YYYY-MM-DD')
    const rol = roles.filter(roles => roles === 'EXPORTADOR')

    TablaConsultaCumplimientoDeCuposService.getEstadisticaCuposNominables(fechaD, fechaH).then(callback)
    function callback (data) {
      const customToolbar = pdfCustomToolbarGenerator(
        'Estadísticas cumplimiento de cupos nominables',
        data,
        CUMPLIMIENTO_CUPO_NOMINABLE_TO_PRINT,
        'landscape'
      )
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: getColumnasNominables(rol),
          data: data,
          title: 'Estadísticas cumplimiento de cupos nominables',
          isLoading: false,
          fixed2Decimales: false,
          extraOptions: {
            customToolbar,
            pagination: false,
            search: false,
            download: true,
            print: false,
            tableBodyMaxHeight: '599px'
          }
        },
        id: TABLA_CUMPLIMIENTO_DE_CUPOS_NOMINABLES
      })
    }
  }
}
